import { createAsyncThunk } from "@reduxjs/toolkit";
import {
  deleteItem,
  fetchData,
  updateItemJson,
} from "../../../../Api/hotelEndpoint";

/***------------- Get All HotelAdmin Data ------------- ***/
export const fetchHotelAdmin = createAsyncThunk(
  "hotel/admin/fetchAll",
  async (params, { rejectWithValue }) => {
    try {
      const { data, totalPages, totalItems } = await fetchData({
        endpoint: "hotel/admin/fetchAll",
        ...params,
      });
      return { data, totalPages, totalItems };
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

/***------------- update HotelAdmin - API ------------- ***/
export const updateHotelAdmin = createAsyncThunk(
  "hotel/admin/update",
  async ({ formData }, { rejectWithValue }) => {
    try {
      const data = await updateItemJson({
        endpoint: "hotel/admin/update",
        formData,
        id: formData._id,
      });
      if (data) return { id: formData._id, data };
      else throw new Error("Request failed");
    } catch (err) {
      return rejectWithValue(err.message);
    }
  }
);

/***------------- Delete Hotel All Data - API ------------- ***/
export const deleteHotelAdmin = createAsyncThunk(
  "hotel/admin/delete",
  async (deleteData, { rejectWithValue }) => {
    try {
      const data = await deleteItem({
        endpoint: "hotel/admin",
        ...deleteData,
      });
      if (data) return data?.id;
      else throw new Error("Request failed");
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

/***------------- Delete-undo Hotel Admin - API ------------- ***/
export const deleteUndoHotelAdmin = createAsyncThunk(
  "hotel/admin/delete-undo",
  async (deleteData, { rejectWithValue }) => {
    try {
      const data = await deleteItem({
        endpoint: "hotel/admin",
        ...deleteData,
        undo: true,
      });
      if (data) return data?.id;
      else throw new Error("Request failed");
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);
